import { render, staticRenderFns } from "./UserCourseSummary.vue?vue&type=template&id=1517ca29&"
import script from "./UserCourseSummary.vue?vue&type=script&lang=js&"
export * from "./UserCourseSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports